import React, { useEffect, useState } from 'react';
import { IHealthPlanMaster } from '../Infrastructure/Interfaces';
import useTable from '../TablePagination/UseTable';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Input,
  Flex,
  useDisclosure,
  Tooltip,
  IconButton,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  useToast,
  Spacer,
  Select,
} from '@chakra-ui/react';
import TablePagination from '../TablePagination/TablePagination';
import { BsPencilSquare } from 'react-icons/bs';
import HealthPlanNameModalPoupup from './HealthPlanMasterModalPopup';
import {
  fetchHealthPlanMasterList,
  setHealthPlanMasterItem,
} from '../Store/HealthPlanMasterReducer';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch } from 'react-redux';
import { FaMapSigns } from 'react-icons/fa';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { ImBin } from 'react-icons/im';

interface Props {
  healthPlanMasterLists: IHealthPlanMaster[];
}

function HealthPlanMasterPg({ healthPlanMasterLists }: Props) {
  const [value, setValue] = useState('');
  const [TableFilter, setTableFilter] = useState(healthPlanMasterLists);
  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    value.length > 0 ? TableFilter : healthPlanMasterLists,
    currentPage,
    claimsPerPage
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch<AppDispatch>();
  const [toBeDeletedItem, setToBeDeleteItem] = useState<IHealthPlanMaster>();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);
  const cancelRef = React.useRef(null);
  const { instance, accounts } = useMsal();
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const toast = useToast();

  function deleteItemDialog(item: IHealthPlanMaster) {
    setToBeDeleteItem(item);
    onDeleteModalOpen();
  }

  async function deleteItem(item: IHealthPlanMaster) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
    const url: string =
      baseurl +
      '/Payer/delete_healthplanname' +
      '?healthplanmasterid=' +
      item.healthPlanMasterId +
      '&userid=' +
      userid;

    await axios.get(tokenurl).then(async res => {
      if (res.data.success) {
        await axios
          .delete(url, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              toast({
                title: 'Success',
                description: item.healthPlanName + ' deleted successfully',
                position: 'top',
                status: 'success',
                duration: 10000,
                isClosable: true,
              });
              onDeleteModalClose();
              dispatch(fetchHealthPlanMasterList());
            }
          })
          .catch(error => {
            toast({
              title: 'Error!',
              description:
                error.response.data.message != ''
                  ? error.response.data.message
                  : error.message,
              position: 'top',
              status: 'error',
              duration: 4000,
              isClosable: true,
            });
            onDeleteModalClose();
          });
      }
    });
    setDeleteOkLoading(false);
  }

  function openModal(id: number) {
    var data = healthPlanMasterLists.find(
      item => item.healthPlanMasterId == id
    );

    let healthPlanName: string = data?.healthPlanName!;
    let healthPlanId: string = data?.healthPlanId!;
    let sendOption1: string = data?.sendOption1!;
    let sendOption2: string = data?.sendOption2!;
    let sendOption3: string = data?.sendOption3!;
    let sendOption4: string = data?.sendOption4!;
    let isActive: boolean = data?.isActive!;
    let createdOn: string = data?.createdOn!;
    let createdBy: string = data?.createdBy!;
    let modifiedBy: string = data?.modifiedBy!;
    let modifiedOn: string = data?.modifiedOn!;

    const item: IHealthPlanMaster = {
      healthPlanMasterId: id,
      healthPlanName: healthPlanName,
      healthPlanId: healthPlanId,
      sendOption1: sendOption1,
      sendOption2: sendOption2,
      sendOption3: sendOption3,
      sendOption4: sendOption4,
      isActive: isActive,
      createdOn: createdOn,
      createdBy: createdBy,
      modifiedBy: modifiedBy,
      modifiedOn: modifiedOn,
    };
    dispatch(setHealthPlanMasterItem(item));
    onOpen();
  }

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = healthPlanMasterLists.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IHealthPlanMaster])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-end" paddingBottom=".5rem">
          <Button
            bg="#002677"
            color="white"
            variant="outline"
            size="md"
            leftIcon={<FaMapSigns />}
            mr={4}
            onClick={() => openModal(0)}
          >
            Add New Health Plan
          </Button>
          <Input
            htmlSize={24}
            width="auto"
            className="form-control"
            type="text"
            placeholder="Search table..."
            onChange={filterData}
            style={{ float: 'right', marginRight: '0.5rem' }}
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white">HEALTH PLAN NAME</Th>
                <Th color="white">HEALTH PLAN ID</Th>
                <Th color="white">ACTIVE</Th>
                {userrole.toUpperCase() != 'USER' && (
                  <Th color="white">
                    ACTIONS
                  </Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {(value.length > 0 ? TableFilter : healthPlanMasterLists)
                .slice(firstIndex, lastIndex)
                .map(healthplanname => {
                  return (
                    <Tr
                      key={healthplanname.healthPlanMasterId}
                      style={{ fontSize: '10px' }}
                    >
                      <Td whiteSpace="pre">{healthplanname.healthPlanName}</Td>
                      <Td whiteSpace="pre">{healthplanname.healthPlanId}</Td>
                      <Td>
                        {healthplanname.isActive == true ? 'True' : 'False'}
                      </Td>
                      {userrole.toUpperCase() != 'USER' && (
                        <Td pt="0" pb="0" mt="0" mb="0">
                          <Tooltip hasArrow label="Edit" placement="left">
                            <IconButton
                              size="xs"
                              aria-label="edit"
                              icon={<BsPencilSquare />}
                              onClick={e =>
                                openModal(healthplanname.healthPlanMasterId)
                              }
                            />
                          </Tooltip>
                          <Tooltip
                            hasArrow
                            label="Delete Item"
                            bg="gray.300"
                            color="black"
                          >
                            <IconButton
                              size="xs"
                              ml={4}
                              aria-label="Delete"
                              icon={<ImBin />}
                              onClick={() => deleteItemDialog(healthplanname)}
                            />
                          </Tooltip>
                        </Td>
                      )}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <HealthPlanNameModalPoupup
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteModalClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Health Plan?
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              Are you sure you want to delete health plan{' '}
              <b>{toBeDeletedItem?.healthPlanName}</b> ?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteModalClose}
                ml={3}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={() => deleteItem(toBeDeletedItem!)}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default HealthPlanMasterPg;
